module.exports = __webpack_public_path__ + "assets/img/3.3641e6f7.jpg";